import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsCheck2, BsClipboard } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';

/**
 * One-time secret display with copy-to-clipboard.
 *
 * Shows a freshly created secret (API key or webhook signing secret) that the backend
 * never returns again, with a clear warning. Used inside the create modals.
 */
const RevealSecret = ({ secret, warning }) => {
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(secret);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch {
			setCopied(false);
		}
	};

	return (
		<div className="space-y-2">
			<div className="flex items-center gap-2">
				<code className="flex-1 break-all rounded-card border border-bgBase-500 bg-bgBase-300 px-3 py-2 font-mono text-sm text-text">
					{secret}
				</code>
				<Button variant="outline" size="sm" onClick={handleCopy}>
					{copied ? <BsCheck2 className="h-4 w-4" /> : <BsClipboard className="h-4 w-4" />}
					{copied ? 'Kopiert' : 'Kopieren'}
				</Button>
			</div>
			<p className="text-xs text-caution-700">{warning}</p>
		</div>
	);
};

RevealSecret.propTypes = {
	secret: PropTypes.string.isRequired,
	warning: PropTypes.string.isRequired,
};

export default RevealSecret;
